import React from 'react'
import PropTypes from 'prop-types'
import { propType } from 'graphql-anywhere'
import gql from 'graphql-tag'
import styled from '@emotion/styled'
import { FormattedMessage } from 'react-intl'
import StreamlineIcon from '@unowmooc/icons'
import config from 'config'

const Link = styled.a`
  flex-shrink: 0;
  font-size: 14px;
  line-height: 25px;
`

const EditIcon = styled(StreamlineIcon)`
  font-size: 16px;
  padding-left: 6px;
`

const EditLink = ({
  section: {
    id: idSection,
    module: { id: idModule, course, courseModuleZero },
  },
  className,
}) => (
  <Link
    target="_blank"
    rel="noopener noreferrer"
    href={`${config.env.ADMIN_URL}/catalogue/formations/${
      courseModuleZero ? courseModuleZero.id : course.id
    }/modules/${idModule}/pages/${idSection}/statistiques-generales`}
    className={className}
  >
    <FormattedMessage id="sections.edit" />
    <EditIcon icon="pencil" />
  </Link>
)

EditLink.fragments = {
  section: gql`
    fragment _ on Section {
      id
      module {
        id
        course {
          id
        }
        courseModuleZero {
          id
        }
      }
    }
  `,
}

EditLink.defaultProps = {
  className: undefined,
}

EditLink.propTypes = {
  section: propType(EditLink.fragments.section).isRequired,
  className: PropTypes.string,
}

export default EditLink
